import {
  APP_STORE_URL,
  LINKEDIN_URL,
  PLAY_STORE_URL,
  SUPPORT_MAILTO,
  YOUTUBE_URL,
} from '../../constants/links';
import { FAQ_ITEMS } from '../../constants/faq';
import { MEDIA } from '../../constants/media';
import { DEFAULT_DESCRIPTION, SITE_NAME, SITE_URL } from '../../constants/seo';

export function getLandingPageJsonLd() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    description: DEFAULT_DESCRIPTION,
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/logo.png`,
    email: 'support@whenwemeet.xyz',
    sameAs: [LINKEDIN_URL, YOUTUBE_URL],
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQ_ITEMS.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  const softwareSchema = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: SITE_NAME,
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web, iOS, Android',
    description: DEFAULT_DESCRIPTION,
    url: SITE_URL,
    image: MEDIA.thumbnail,
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
    },
    downloadUrl: [APP_STORE_URL, PLAY_STORE_URL],
  };

  return [websiteSchema, organizationSchema, faqSchema, softwareSchema];
}

export function getAppPageJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: `${SITE_NAME} Mobile App`,
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'iOS, Android',
    description:
      'Take group scheduling anywhere. Create meeting planners, share availability, and find the perfect time from your phone.',
    url: `${SITE_URL}/app`,
    image: MEDIA.thumbnail,
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
    },
    downloadUrl: [APP_STORE_URL, PLAY_STORE_URL],
  };
}

export function getSupportPageJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Help & Support - WhenWeMeet',
    url: `${SITE_URL}/support`,
    description:
      'Get help with WhenWeMeet. Contact support, report bugs, send feedback, or find answers to common questions.',
    isPartOf: {
      '@type': 'WebSite',
      name: SITE_NAME,
      url: SITE_URL,
    },
    mainEntity: {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      email: 'support@whenwemeet.xyz',
      url: SUPPORT_MAILTO,
    },
  };
}
